import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { Button, Container, FormLabel, Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { cyrb53 } from "../tools/cybr54";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      width: 400,
    },
  },
  content: {
    marginTop: 30,
  },
}));

export default function AuthForm() {
  const classes = useStyles();

  const [error, setError] = React.useState(false);

  const [value, setValue] = React.useState("");
  const handleChange = (event) => {
    setValue(event.target.value);
    setError(false);
  };

  const handleClick = () => {
    if (cyrb53(value) === cyrb53(process.env.REACT_APP_SECRET)) {
      localStorage.setItem("secret", cyrb53(value));
      window.location.reload();
    } else {
      setError(true);
      setValue("");
    }
  };

  return (
    <Container className={classes.content}>
      <Grid
        container
        direction={"column"}
        justify={"center"}
        alignItems={"center"}
        spacing={5}
      >
        <Grid item>
          <img
            src={"/images/nirvana-logo.png"}
            style={{
              width: 150,
              objectFit: "contain",
            }}
          />
          <Typography variant={"overline"}> Admin</Typography>
        </Grid>
        <Grid item>
          <form className={classes.root} noValidate autoComplete="off">
            <Grid container direction={"column"} spacing={3}>
              <Grid item>
                <TextField
                  fullWidth
                  id="outlined-basic"
                  label="Password"
                  variant="outlined"
                  value={value}
                  onChange={handleChange}
                  error={error}
                />
              </Grid>
              <Grid item>
                <Button
                  variant={"contained"}
                  fullWidth
                  color={"primary"}
                  size={"large"}
                  onClick={handleClick}
                >
                  Enter
                </Button>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </Container>
  );
}



// WEBPACK FOOTER //
// ./src/components/AuthForm.js